import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, Download, Loader2 } from 'lucide-react';

// One file's download button, opening onto its formats. `busy` holds the spinner once the menu has closed.
function DownloadMenu({ label, items, onPick, busy = false, disabled = false, primary = false, title, className = '', testId }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onMouseDown = (e) => {
      if (!rootRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.document.addEventListener('mousedown', onMouseDown);
    window.document.addEventListener('keydown', onKey);
    return () => {
      window.document.removeEventListener('mousedown', onMouseDown);
      window.document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const pick = (item) => {
    setOpen(false);
    onPick(item.type, item.format);
  };

  return (
    <div className="action-menu" ref={rootRef}>
      <button
        className={`btn ${primary ? 'btn-primary' : 'btn-secondary'} action-menu-trigger ${className}`}
        onClick={() => setOpen((o) => !o)}
        disabled={disabled || busy}
        title={title}
        aria-haspopup="menu"
        aria-expanded={open}
        data-testid={testId}
      >
        {busy ? <Loader2 size={16} className="btn-spin" /> : <Download size={16} />}
        <span>{label}</span>
        <ChevronDown size={16} className="action-menu-chevron" />
      </button>
      {open && (
        <div className="action-menu-dropdown" role="menu">
          {items.map((item) => (
            <button
              key={item.testId}
              role="menuitem"
              className="action-menu-item"
              onClick={() => pick(item)}
              title={item.title}
              data-testid={item.testId}
            >
              <span className="action-menu-item-label">{item.label}</span>
              <span className="action-menu-item-hint">{item.hint}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default DownloadMenu;
